import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatPercent } from '../utils/helpers';

type Size = 'sm' | 'md' | 'lg';

interface PriceChangeProps {
  value: number;
  showIcon?: boolean;
  size?: Size;
}

const PriceChange: React.FC<PriceChangeProps> = ({ value, showIcon = true, size = 'md' }) => {
  const isPositive = value >= 0;
  const sizeClasses: Record<Size, string> = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  const iconSize = size === 'lg' ? 18 : size === 'sm' ? 12 : 14;

  return (
    <span
      className={`inline-flex items-center gap-1 font-mono ${sizeClasses[size]} ${
        isPositive ? 'text-emerald-400' : 'text-red-400'
      }`}
    >
      {showIcon && (isPositive ? <TrendingUp size={iconSize} /> : <TrendingDown size={iconSize} />)}
      {formatPercent(value, true)}
    </span>
  );
};

export default PriceChange;
